import React, { FC } from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../hooks';
import { ICallerСС } from 'store/models/callCardStore';
import { ITag } from '../../../views/authorized/pages/telephony/types';
import { Button } from 'components/ui';
import { TagItem } from './components';
import {
  IconAdd,
  SelectedTagWrapper,
  SelectTagSpan,
  StyledPortal,
  TagListItem,
  TagsList,
  Wrapper,
} from './tag-selection.styled';

interface Props {
  id: string;
  tag: ITag | null;
  isCallCard?: {
    caller: ICallerСС;
    updateTag: (tag: ITag) => void;
  };
}

export const TagSelection: FC<Props> = observer(({ id, tag, isCallCard }) => {
  const { telephony, constants } = useStore();

  const changeTagInCallCard = (value: string) => {
    const selectTag = tag?.tag === value ? 'empty' : value;

    telephony.updateCall(id, { tag: selectTag });

    if (isCallCard) {
      isCallCard.updateTag({
        author: {
          id: isCallCard.caller.id || '',
          name: isCallCard.caller.name || 'Неизвестный абонент',
        },
        date: new Date().toString(),
        tag: selectTag,
      });
    }
  };

  const changeTagInReport = (value: string) => {
    if (
      telephony.selectedCall &&
      value === 'not_relevant' &&
      !telephony.allCallsSelected
    ) {
      telephony.removeNotRelevantCall(telephony.selectedCall.id);
    }

    const selectTag = tag?.tag === value ? 'empty' : value;

    telephony.changeTag(id, { tag: selectTag });
  };

  const handleClickTag = (e: Event, item: { value: string; text: string }) => {
    e.stopPropagation();
    isCallCard
      ? changeTagInCallCard(item.value)
      : changeTagInReport(item.value);
  };

  return (
    <>
      {!isCallCard ? (
        <DropdownMenu.Root>
          <SelectedTagWrapper onClick={(e) => e.stopPropagation()}>
            {!!tag?.tag ? <TagItem tag={tag.tag} /> : <IconAdd />}
          </SelectedTagWrapper>
          <StyledPortal
            onClick={(e: React.MouseEvent<HTMLDivElement>) =>
              e.stopPropagation()
            }
          >
            <TagsList
              onClick={(e: React.MouseEvent<HTMLDivElement>) =>
                e.stopPropagation()
              }
            >
              <SelectTagSpan>Выберите тег</SelectTagSpan>
              {constants.telephony?.Tag?.filter(
                (item: { value: string; text: string }) => item.text !== ''
              ).map((item: { value: string; text: string }) => (
                <TagListItem
                  key={item.value}
                  onSelect={(e) => handleClickTag(e, item)}
                >
                  <TagItem tag={item.value} />
                </TagListItem>
              ))}
            </TagsList>
          </StyledPortal>
        </DropdownMenu.Root>
      ) : (
        <Wrapper>
          {constants.telephony?.Tag?.filter(
            (item: { value: string; text: string }) => item.text !== ''
          ).map((item: { value: string; text: string }) => (
            <Button
              mode="neutral"
              variant="main"
              size="s"
              selected={!!tag && tag.tag === item.value}
              key={item.value}
              onClick={() => changeTagInCallCard(item.value)}
            >
              <TagItem tag={item.value} />
            </Button>
          ))}
        </Wrapper>
      )}
    </>
  );
});
